import MediaZoomModal from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMediaCarousel/MediaZoomModal/MediaZoomModal';

export default MediaZoomModal;
